import React from 'react';
import { WidgetLink } from './WidgetLink';
import { WidgetTruncatedText } from './WidgetTruncatedText';
import { useTranslation } from 'react-i18next';
import { Box, Typography } from '@mui/material';
import { levels } from '../../constants/paymentLinks/level';

export function WidgetLevelLinkText ({ to, text, options = {}, styles, truncated, levelId, noBubble }) {
    const { t } = useTranslation();
    const formattedText = /\..*\./.test(text) ? t(text) : text;
    const emptyText = text === 'S/D';
    const level = levelId ? levels.find(level => level.id === levelId) : undefined;
    const levelStyles = { ...level?.styles, textDecoration: to ? 'underline' : 'none' };

    const getBoxStyles = () => ({
        position: 'relative',
        padding: level ? '8px 16px' : '0',
        width: '98px',
        justifyContent: 'center',
        justifySelf: 'center',
        display: 'flex',
        borderRadius: '2rem',
        backgroundColor: levelStyles?.backgroundColor,
        color: levelStyles?.color,
    });

    const getBadgeStyles = () => ({
        position: 'absolute',
        top: '-0.25rem',
        right: '-0.70rem',
        borderRadius: '50%',
        backgroundColor: level?.badgeStyles?.backgroundColor,
        padding: '2px 8px',
    });

    const renderText = () => {
        return (
            <WidgetTruncatedText text={emptyText ? '-' : formattedText} options={options} styles={levelStyles} truncated={truncated} />
        );
    };

    return (
        <Box component={'div'} sx={getBoxStyles()}>
            {!to ? renderText()
                : <WidgetLink to={to} text={renderText() } color={levelStyles?.color} />}
            {level && !noBubble &&
                <Box component={'div'} sx={getBadgeStyles()}>
                    <Typography color={level?.badgeStyles?.color} fontWeight={level?.badgeStyles?.fontWeight} fontSize={'12px'}>
                        {level?.level.slice(0, 1)}
                    </Typography>
                </Box>
            }
        </Box>
    );
}

// Set display names for debugging.
if (process.env.NODE_ENV !== 'production') {
    WidgetLevelLinkText.displayName = 'WidgetLinkTruncatedText';
}
